import { isTerminalNavigateGoalStatus } from "lib/consts/navigateGoalStatus";

/** Read numeric GoalStatus code from a status_list entry (handles rosbridge nesting). */
export function goalStatusCode(entry) {
    if (!entry) return null;
    const status = entry.status;
    if (typeof status === "number") return status;
    if (status && typeof status.status === "number") return status.status;
    return null;
}

/** True when GoalStatusArray has at least one active navigate_to_pose goal. */
export function hasActiveNavigateToPoseGoal(statusArrayMsg) {
    const list = statusArrayMsg?.status_list;
    if (!Array.isArray(list) || list.length === 0) return false;
    return list.some((entry) => {
        const code = goalStatusCode(entry);
        return code != null && !isTerminalNavigateGoalStatus(code);
    });
}
